import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import tashiActions from '../actions/tashiActionCreators';
import { Modal } from 'react-bootstrap';

class VersionMismatchModal extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // EVENT HANDLERS

    handleReload = () => {
        location.reload(true);
    }

    handleClose = () => {
        this.props.dispatch(tashiActions.clearVersionError());
    }

    handleRefocus = () => {
        ReactDOM.findDOMNode(this.refs.reloadButton).focus();
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true} onRequestHide={() =>{}} className="modal fade" id="myModal4" tabIndex="-1" role="dialog" aria-labelledby="myModal4Label" aria-hidden="true">
                <div ref="modalBody" className="modal-dialog new-log-entry">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="myModalLabel">
                                Reload application
                            </h4>
                        </div>
                        <div ref="modalBody" className="modal-body">
                            <h4>
                                Tashi has been updated. <br/><br/>
                                Click Reload to start using the new version
                            </h4>
                        </div>
                        <div className="modal-footer">
                            <button title="Reload the application" ref="reloadButton" type="button" className="btn btn-default btn-discrete" onClick={this.handleReload}>
                                Reload
                            </button>
                            <button title="Do not reload" ref="closeButton" type="button" className="btn btn-default btn-large" onBlur={this.handleRefocus} onClick={this.handleClose}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

VersionMismatchModal.propTypes = {
    dispatch: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VersionMismatchModal);



/** WEBPACK FOOTER **
 ** ./src/app/components/VersionMismatchModal.js
 **/